(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["overlay-follow-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("overlay-follow-content")) {
    customElements.define("overlay-follow-content", class OverlayFollowContent extends HTMLElement {
      connectedCallback() {
        this.updatePosition = this.updatePosition.bind(this);
        this.resizeObserver = new ResizeObserver(this.updatePosition);
        this.resizeObserver.observe(this);
        window.addEventListener("resize", this.updatePosition, { passive: true });
        window.visualViewport?.addEventListener("resize", this.updatePosition, { passive: true });
        this.updatePosition();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.removeEventListener("resize", this.updatePosition);
        window.visualViewport?.removeEventListener("resize", this.updatePosition);
      }

      updatePosition() {
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const stickyArea = Number.parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue("--sticky-area-height")
        ) || 0;

        if (this.offsetHeight + stickyArea >= viewportHeight) {
          this.removeAttribute("ready");
          return;
        }

        this.style.setProperty("--overlay-follow-top", `${viewportHeight - this.offsetHeight}px`);
        this.setAttribute("ready", "");
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
